import React, { useState, useEffect } from "react";
import HeroSection from "../../components/HeroSection";
import OnlineCourses from "../../components/OnlineCourses";
import OurInstructours from "../../components/Our-Instructors";
import PopularInstructor from "../../components/Popular-Instructours";
import TrustedCompanies from "../../components/TrustedCompanies";
import WhyChoose from "../../components/WhyChoose";

function Home() {
  const [userType, setUserType] = useState('');

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userDataLogin"));
    if (userData?.userType) {
      setUserType(userData.userType);
    }
  }, []);

  // If user is a teacher, show limited sections
  if (userType === "teacher") {
    return (
      <>
        <HeroSection />
        <TrustedCompanies />
        <OnlineCourses isTeacher={true} />
        <WhyChoose />
      </>
    );
  }

  // For regular users (student/parent), show all sections
  return (
    <>
      <HeroSection />
      <PopularInstructor />
      <OurInstructours />
      <TrustedCompanies />
      <OnlineCourses />
      <WhyChoose />
    </>
  );
}

export default Home;
